import React from "react";
import { createPortal } from "react-dom";

// Delete-list confirm. Copy is verbatim from the design source and must not change:
// title + "Players in this list move to My Radar. Nothing is removed from your
// radar." Desktop = centred modal; mobile = bottom sheet.
const DeleteListModal = ({ listName, mobile = false, onCancel, onConfirm }) => {
  const bodyCopy = (
    <>
      Players in this list move to <b className="text-[#374151]">My Radar</b>. Nothing is removed from your radar.
    </>
  );

  if (mobile) {
    return createPortal(
      <div className="fixed inset-0 z-[80] flex items-end" role="dialog" aria-modal="true">
        <div className="absolute inset-0 bg-[rgba(17,24,39,0.4)]" onClick={onCancel} aria-hidden="true" />
        <div className="relative w-full bg-white rounded-t-[18px]" style={{ padding: "8px 16px 40px" }}>
          <div className="w-9 h-1 rounded-full bg-[#DDE3EB] mx-auto mt-1 mb-3.5" aria-hidden="true" />
          <div className="text-[15px] font-bold text-[#111827] mb-1.5">Delete &quot;{listName}&quot;?</div>
          <div className="text-[13px] text-[#6B7280] leading-[1.55] mb-4">{bodyCopy}</div>
          <button
            type="button"
            onClick={onConfirm}
            className="w-full h-12 bg-[#DC2626] text-white border-none rounded-[9px] text-[14px] font-semibold cursor-pointer mb-2"
          >
            Delete list
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="w-full h-12 bg-white border border-[#DDE3EB] rounded-[9px] text-[14px] font-semibold text-[#374151] cursor-pointer"
          >
            Cancel
          </button>
        </div>
      </div>,
      document.body,
    );
  }

  return createPortal(
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-[rgba(17,24,39,0.4)]" role="dialog" aria-modal="true">
      <div className="absolute inset-0" onClick={onCancel} aria-hidden="true" />
      <div
        className="relative bg-white"
        style={{ width: 380, maxWidth: "90vw", borderRadius: 14, boxShadow: "0 24px 64px rgba(17,24,39,0.24)", padding: 20 }}
      >
        <div className="text-[15px] font-bold text-[#111827]" style={{ marginBottom: 6 }}>Delete &quot;{listName}&quot;?</div>
        <div className="text-[12.5px] text-[#6B7280] leading-[1.55]" style={{ marginBottom: 16 }}>{bodyCopy}</div>
        <div className="flex justify-end" style={{ gap: 8 }}>
          <button
            type="button"
            onClick={onCancel}
            className="bg-white border border-[#DDE3EB] hover:bg-[#F8FAFC] text-[#374151] font-semibold cursor-pointer"
            style={{ borderRadius: 9, padding: "8px 14px", fontSize: 12.5 }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="bg-[#DC2626] hover:bg-[#B91C1C] text-white border-none font-semibold cursor-pointer"
            style={{ borderRadius: 9, padding: "8px 14px", fontSize: 12.5 }}
          >
            Delete list
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default DeleteListModal;
